import { Subject } from 'rxjs';

const subject = new Subject();

export const annotationResolveService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};